// Discriminates image vs video by file extension. Backend doesn't store the
// MIME type (would leak metadata), so we derive it from the (decrypted)
// filename. Unknown extensions default to image so the viewer at least tries
// to render via <img>.

const VIDEO_EXT = new Set(['mp4', 'm4v', 'mov', 'webm', 'mkv', 'avi', 'ogv', '3gp', '3g2']);

export type MediaKind = 'image' | 'video';

export function mediaKindOf(filename: string): MediaKind {
  const dot = filename.lastIndexOf('.');
  if (dot < 0) return 'image';
  const ext = filename.slice(dot + 1).toLowerCase();
  return VIDEO_EXT.has(ext) ? 'video' : 'image';
}
